import { Observable, of } from 'rxjs';

import { SearchResult } from '@common/models/search-result';

export class SearchCategory<T>
{
    public results: Observable<SearchResult<T>[]> = of([]);
}
